/*!
// <copyright file="uwa-proxy.js" company="Microsoft">
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
*/

(function () {
    'use strict';

    $dyn.uwa = $dyn.uwa || {};

    // Indicates whether Windows Universal APIs are available or not
    $dyn.uwa.isUWA = (typeof Windows !== 'undefined' &&
                      typeof Windows.UI !== 'undefined' &&
                      typeof Windows.ApplicationModel !== 'undefined');

    if ($dyn.uwa.isUWA) {
        $(document).ready(function () {
            // notify the app host Ax site loaded
            postMessage("AXSiteLoaded", true);

            // Subscribe to navigation stack to notify the app host to show/hide back button
            $dyn.observe($dyn.shell.canGoBack, function (newvalue) {
                var showBackButton = $dyn.value(newvalue);
                postMessage("ShowBackButton", showBackButton);
            });
        });

        $dyn.uwa.openInExternalBrowser = function (url) {
            postMessage("ExternalUrl", url);
        };

        var postMessage = function (type, argument) {
            var message = { Type: type, Argument: argument };
            window.external.notify(JSON.stringify(message));
        };
    }

})();
